let arr = [
  {
    sysLanguageId: 7,
    sysLanguageCode: "en_GB",
    sysLanguageName: "English",
  },
  {
    sysLanguageId: 9,
    sysLanguageCode: "es_ES",
    sysLanguageName: "Español",
  },
  {
    sysLanguageId: 14,
    sysLanguageCode: "fr_FR",
    sysLanguageName: "Français",
  },
  {
    sysLanguageId: 24,
    sysLanguageCode: "pt_PT",
    sysLanguageName: "Português",
  },
  {
    sysLanguageId: 34,
    sysLanguageCode: "zh_CN",
    sysLanguageName: "简体中文",
  },
  {
    sysLanguageId: 35,
    sysLanguageCode: "zh_TW",
    sysLanguageName: "繁体中文",
  },
  {
    sysLanguageId: 36,
    sysLanguageCode: "id_ID",
    sysLanguageName: "Bahasa Indonesia",
  },
  {
    sysLanguageId: 37,
    sysLanguageCode: "de_DE",
    sysLanguageName: "Deutsch",
  },
  {
    sysLanguageId: 38,
    sysLanguageCode: "it_IT",
    sysLanguageName: "Italiano",
  },
  {
    sysLanguageId: 39,
    sysLanguageCode: "pl_PL",
    sysLanguageName: "Polski",
  },
  {
    sysLanguageId: 40,
    sysLanguageCode: "ru_RU",
    sysLanguageName: "Русский",
  },
  {
    sysLanguageId: 41,
    sysLanguageCode: "vi_VN",
    sysLanguageName: "Tiếng Việt",
  },
  {
    sysLanguageId: 42,
    sysLanguageCode: "th_TH",
    sysLanguageName: "ไทย",
  },
  {
    sysLanguageId: 43,
    sysLanguageCode: "ar_SA",
    sysLanguageName: "العربية",
  },
  {
    sysLanguageId: 44,
    sysLanguageCode: "ja_JP",
    sysLanguageName: "日本語",
  },
  {
    sysLanguageId: 45,
    sysLanguageCode: "ko_KR",
    sysLanguageName: "한국어",
  },
  {
    sysLanguageId: 46,
    sysLanguageCode: "my_MM",
    sysLanguageName: "မြန်မာဘာသာ",
  },
  {
    sysLanguageId: 47,
    sysLanguageCode: "km_KH",
    sysLanguageName: "ភាសាខ្មែរ",
  },
]
export default arr;

let res = localStorage.getItem("lang");
const sysLang = navigator.language;
const lang = sysLang.substring(0, 2);

if (!res) {
  res = "";
  switch (lang) {
    case "ar":
      res = "ar_SA";
      break;
    case "bg":
      res = "bg_BG";
      break;
    case "ca":
      res = "ca_ES";
      break;
    case "cs":
      res = "cs_CZ";
      break;
    case "de":
      res = "de_DE";
      break;
    case "el":
      res = "el_GR";
      break;
    case "en":
      res = "en_GB";
      break;
    case "es":
      res = "es_ES";
      break;
    case "et":
      res = "et_EE";
      break;
    case "fa":
      res = "fa_IR";
      break;
    case "fi":
      res = "fi_FI";
      break;
    case "fr":
      res = "fr_FR";
      break;
    case "it":
      res = "it_IT";
      break;
    case "ja":
      res = "ja_JP";
      break;
    case "ko":
      res = "ko_KR";
      break;
    case "nl":
      res = "nl_NL";
      break;
    case "pl":
      res = "pl_PL";
      break;
    case "sk":
      res = "sk_SK";
      break;
    case "sr":
      res = "sr_RS";
      break;
    case "sl":
      res = "sl_SI";
      break;
    case "sv":
      res = "sv_SE";
      break;
    case "th":
      res = "th_TH";
      break;
    case "tr":
      res = "tr_TR";
      break;
    case "ru":
      res = "ru_RU";
      break;
    case "uk":
      res = "uk_UA";
      break;
    case "vi":
      res = "vi_VN";
      break;
    case "zh":
      res = "zh_CN";
      break;
    case "id":
      res = "id_ID";
      break;
    case "pt":
      res = "pt_PT";
      break;
    default:
      res = "en_GB";
      break;
  }
}
export const langDefault = res